// Reusable skeleton primitives. Replace ad-hoc Loader2 spinners with these
// on data-heavy lists/tables — they convey "real layout incoming" instead
// of "wait" and reduce perceived load time.

interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

export function Skeleton({ className = '', width, height }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded bg-slate-200/70 ${className}`}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    />
  );
}

/** Skeleton for a typical table row — reuse across leads / users / etc. */
export function TableRowSkeleton({ columns = 6 }: { columns?: number }) {
  return (
    <tr className="border-t border-slate-100">
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="px-4 py-3">
          <Skeleton height={14} width={i === 0 ? '70%' : '85%'} />
        </td>
      ))}
    </tr>
  );
}

/** Skeleton for a card-style row (mobile lead list). */
export function CardRowSkeleton() {
  return (
    <div className="px-4 py-3 border-t border-slate-100">
      <Skeleton height={14} width="60%" className="mb-2" />
      <Skeleton height={11} width="40%" className="mb-1" />
      <Skeleton height={11} width="50%" />
    </div>
  );
}
